export default function ({state, getters, commit}, val) {
    if (getters.disabled_date_pay) return;
    commit('set_form', {
        PaymentDate: val,
    });
}